import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ROUTE } from "../constants/routes";
import { useAuth } from "./useAuth";

const PublicOnlyRoute: React.FC = () => {
  const auth = useAuth();
  const location = useLocation();

  const returnToRaw = new URLSearchParams(location.search).get("returnTo") || "";
  const returnTo =
    returnToRaw.startsWith("/") && !returnToRaw.startsWith("//")
      ? returnToRaw
      : null;

  if (auth.isLoading) {
    return (
      <div role="status" aria-live="polite" style={{ textAlign: "center" }}>
        <span style={{ position: "absolute", left: -9999 }}>
          Verificando sua sessão...
        </span>
        Carregando…
      </div>
    );
  }

  if (auth.isAuthenticated) {
    return <Navigate to={returnTo ?? ROUTE.APP_HOME} replace />;
  }

  return <Outlet />;
};

export default PublicOnlyRoute;
